import { format, parse } from "date-fns";
import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  createDateFilter,
  getMinSelectableDate,
  VALIDATION_PRESETS
} from "../../../../../utils/dateValidation";


const UpdateNextBookingDate2DModal = ({
  show, onHide, nextBookingDate2D, setNextBookingDate2D, onChangeBookingDate
}) => {
  const [selectedDate, setSelectedDate] = useState(undefined)

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (show) {
      setLoading(false)
    }
  }, [show])

  useEffect(() => {
    if (nextBookingDate2D) {
      setSelectedDate(parse(nextBookingDate2D, "dd/MM/yyyy", new Date()))
    }
  }, [nextBookingDate2D])

  // Determine modal size - responsive by default
  const getModalSize = () => {
    // Responsive logic based on screen size
    if (typeof window !== "undefined") {
      const width = window.innerWidth;
      if (width < 576) return "lg";
      if (width < 768) return "md";
      return "md";
    }
    return "md";
  };

  return (
    <Modal show={show} onHide={onHide} size={getModalSize()} centered>
      <Modal.Header closeButton>
        <Modal.Title><h5 className="modal-title">Update 2D Next Available Booking Date</h5></Modal.Title>
      </Modal.Header>
      <div className="modal-body px-md-5 px-2">
        <form>
          <div className="form-group">
            <div style={{ fontSize: "25px" }}>
              <div className="ca-custom">
                <DatePicker
                  selected={selectedDate}
                  onChange={date => {
                    setSelectedDate(date)
                  }}
                  closeOnScroll={e => e.target === document}
                  className="form-control mb-2 mt-2 ml-1 "
                  dateFormat="dd/MM/yyyy"
                  minDate={getMinSelectableDate()}
                  filterDate={createDateFilter(VALIDATION_PRESETS.BOOKING_DATES)} />
              </div>

            </div>
          </div>
        </form>
        <div className="modal-footer d-flex justify-content-between p-0 mb-4 mt-5">
          <button className="btn btn-light btn-lg" data-dismiss="modal" type="button" onClick={onHide}>Close</button>
          <button
            disabled={loading}
            className="btn btn-red btn-lg"
            onClick={() => {
              setNextBookingDate2D(format(selectedDate, "dd/MM/yyyy", new Date()))
              onChangeBookingDate(format(selectedDate, "dd/MM/yyyy", new Date()), "next_booking_date_2d")
              setLoading(true)
            }}
            type="submit">
            Save Changes
            {loading && <Spinner className="ml-1" animation="border" role="status" size="sm" />}
          </button>
        </div>
      </div>
    </Modal>
  )
}
export default UpdateNextBookingDate2DModal
